/**
 * Shared marketplace + member catalog constants.
 * Single source of truth for product categories (all types, international-friendly)
 * and the country dropdown used in profile/role-select forms.
 */

export const CATEGORIES = [
  // Core produce
  { id: "vegetables", label: "Vegetables" },
  { id: "fruits", label: "Fruits" },
  { id: "herbs", label: "Herbs & Spices" },
  { id: "mushrooms", label: "Mushrooms" },
  { id: "grains", label: "Grains & Flour" },
  { id: "seeds", label: "Heritage Seeds" },
  { id: "flowers", label: "Cut Flowers & Plants" },
  // Animal / protein
  { id: "meats", label: "Meats" },
  { id: "poultry", label: "Poultry" },
  { id: "seafood", label: "Fish & Seafood" },
  { id: "dairy", label: "Dairy" },
  { id: "eggs", label: "Eggs" },
  { id: "honey", label: "Honey & Beekeeping" },
  { id: "livestock", label: "Live Animals" },
  // Made on the farm
  { id: "baked", label: "Bread & Baked Goods" },
  { id: "preserves", label: "Preserves & Pickles" },
  { id: "beverages", label: "Beverages (cider, kombucha, wine)" },
  { id: "prepared", label: "Prepared Meals" },
  { id: "handmade", label: "Handmade Goods (soaps, candles)" },
  // Beyond food
  { id: "services", label: "Services (farm tours, classes, CSA)" },
  { id: "tools", label: "Tools & Equipment" },
  // Listing types
  { id: "wholesale", label: "Wholesale" },
  { id: "free", label: "Free" },
  { id: "barter", label: "Barter" },
  { id: "mutation", label: "Mutation / Imperfect Produce" },
];

// id-only list used by the Add Product Select on the Farmer Dashboard
export const CATEGORY_IDS = CATEGORIES.map((c) => c.id);

// Map of id -> human label (cards / chips render this)
export const CATEGORY_LABEL = Object.fromEntries(CATEGORIES.map((c) => [c.id, c.label]));

// Marketplace filter — same list with an "All" prepended
export const MARKETPLACE_FILTERS = [{ id: "all", label: "All" }, ...CATEGORIES];

/**
 * Countries — sorted alphabetically, US first because it's our home market.
 * ISO 3166 short list of the most common hobby-farming regions; the dropdown also
 * allows "Other / not listed" with a free-text fallback for any country not below.
 */
export const COUNTRIES = [
  "United States",
  "Canada", "Mexico",
  "United Kingdom", "Ireland",
  "Australia", "New Zealand",
  "Argentina", "Brazil", "Chile", "Colombia", "Peru",
  "France", "Germany", "Italy", "Netherlands", "Portugal", "Spain", "Sweden", "Norway", "Denmark", "Finland", "Switzerland", "Belgium", "Austria", "Poland",
  "Greece", "Croatia", "Romania", "Czech Republic", "Hungary",
  "South Africa", "Kenya", "Nigeria", "Ghana", "Egypt", "Morocco",
  "India", "Sri Lanka", "Nepal", "Bangladesh", "Pakistan",
  "Japan", "South Korea", "Philippines", "Thailand", "Indonesia", "Vietnam", "Malaysia", "Singapore",
  "China", "Taiwan", "Hong Kong",
  "United Arab Emirates", "Saudi Arabia", "Israel", "Türkiye",
  "Other / not listed",
];
